import { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { useSelectItemsTranslate } from "@ryde/redux";
import {
  errors,
  IStyledAttributes,
  Log,
  NO_VALUE_DISPLAY,
  RideStatusEnum,
  useIsMobile,
} from "@ryde/shared";
import { MOBILE_BREAKPOINT } from "@ryde/theme";

import {
  IRideStatusIndicator,
  IRideStatusIndicatorControl,
  RideStatusIndicatorConst,
} from "./ride-status.indicator.models";

const RideStatusFilledIndicatorStyled = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "ride-status-filled-indicator",
})<IRideStatusIndicatorControl>`
  margin-inline-start: auto;
  height: 22px;
  gap: 10px;
  padding: 4px 10px;
  background-color: ${props => props.$bgColor};
  border-inline-start: 2px solid ${props => props.$leftColor};
  color: ${props => props.color};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: ${props => props.fontSize || "12px"};
  font-weight: 400;
  border-radius: 3px;
  @media (max-width: ${MOBILE_BREAKPOINT}) {
    width: 35px;
  }
`;

export const RideStatusFilledIndicator: FC<IRideStatusIndicator> = ({
  status,
  fontSize,
}) => {
  const info = RideStatusIndicatorConst[status || RideStatusEnum.New];

  const { t } = useTranslation();

  if (!info) {
    Log.warn(t(errors.ride.invalidRideStatus), status);
  }

  const { translateLabel } = useSelectItemsTranslate();
  const { isMobile } = useIsMobile();
  const statusText = useMemo(() => {
    if (!status || !info?.$translateKey) {
      return NO_VALUE_DISPLAY;
    }

    const text = translateLabel(info.$translateKey) || "";

    if (!isMobile) {
      return text;
    }

    return text.at(0) || "";
  }, [info?.$translateKey, isMobile, status, translateLabel]);

  return (
    <RideStatusFilledIndicatorStyled
      className="status_Filled_indicator"
      {...info}
      fontSize={fontSize}
    >
      {statusText}
    </RideStatusFilledIndicatorStyled>
  );
};
